import { apiConfig } from "@/helpers";
import { authHeader } from '../helpers';
import axios from 'axios';

export const slownikiService = {

    GetMedicalChambers,
    GetProduktyLecznicze
};

function GetMedicalChambers()
{
    return axios.get('/api/services/app/Slowniki/GetMedicalChambers', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader()
    })
}
function GetProduktyLecznicze(nazwa)
{
    return axios.get('/api/services/app/P1Service/GetProduktyLecznicze', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            nazwa: nazwa
        }
    })
}